import EasyValidation from './validationHelper.js';

// Variables
const validate = new EasyValidation();
const txtFullName = document.getElementById('txtFullName');
const txtEmail = document.getElementById('txtEmail');
const txtLocation = document.getElementById('txtLocation');

const txtMobile = document.getElementById('txtMobile');
const txtFile = document.getElementById('txtFile');
const textProfileURL = document.getElementById('txtProfileURL');
const txtHearJob = document.getElementById('txtHearJob');

// const txtCoverLetter = document.getElementById('txtCoverLetter');
const txtCurrentCompany = document.getElementById('txtCurrentCompany');

const txtCurrentTitle = document.getElementById('txtCurrentTitle');
const txtCurrentExperience = document.getElementById('txtCurrentExperience');

const btnSubmit = document.getElementById('btnSubmit');
const lblMsg = document.getElementById('lblMsg');

let currentDaTeTime = new Date().getMilliseconds();

const SUBMIT = 'SUBMIT';

// local api  url
// const FILE_UPLOAD_URL = `http://172.16.61.30:121/Api/EJoining/UploadResume?newFileName=${currentDaTeTime}`;
// const API_URL = `http://172.16.61.30:121/Api/Recruiter/ManualJobApply`;

// live api url
const FILE_UPLOAD_URL = `http://182.156.200.178:121/Api/EJoining/UploadResume?newFileName=${currentDaTeTime}`;
const API_URL = `http://182.156.200.178:121/Api/Recruiter/ManualJobApply`;

let submitCount = 0;

window.addEventListener('load', () => {
  lblMsg.innerHTML = '';
  submitCount = 0;
});
// validate First Name
txtFullName.addEventListener('blur', () => {
  validate.name(txtFullName);
});

txtLocation.addEventListener('blur', () => {
  validate.location(txtLocation);
});

// // validate Mobile
txtMobile.addEventListener('blur', () => {
  validate.number(txtMobile);
});
// // validate email
txtEmail.addEventListener('blur', () => {
  validate.email(txtEmail);
});

// // validate File
txtFile.addEventListener('change', async () => {
  validate.fileValidation(txtFile);
});

// txtCoverLetter.addEventListener('change', async () => {
//   validate.fileValidation(txtCoverLetter);
// });

txtCurrentCompany.addEventListener('blur', async () => {
  validate.minText(txtCurrentCompany);
});

txtCurrentTitle.addEventListener('blur', async () => {
  validate.minText(txtCurrentTitle);
});
txtCurrentExperience.addEventListener('change', async () => {
  validate.currentExperience(txtCurrentExperience);
});

//api Calling
const postWith = async (url, data, isJson = false) => {
  let response;

  if (isJson === false) {
    response = await fetch(url, {
      method: 'POST',
      body: data,
    });
  } else {
    response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  return await response.json();
};

//Create Json
const jsonData = async () => {
  let json = {};
  json.name = txtFullName.value;
  json.mobilenumber = txtMobile.value;
  json.email = txtEmail.value;
  json.currentLocation = txtLocation.value;
  json.currentCompany = txtCurrentCompany.value;
  json.currentTitle = txtCurrentTitle.value;
  json.totalExperience = txtCurrentExperience.value;
  json.profileURL = txtProfileURL.value;
  json.sourceofCV = txtHearJob.options[txtHearJob.selectedIndex].value;
  json.companyId = 6;
  return json;
};

const objToFormData = (data) => {
  const formData = new FormData();
  for (var key in data) {
    formData.append(key, data[key]);
  }
  formData.append('resumeUpload', txtFile.files[0]);
  // form_data.append('cover letter', txtCoverLetter.files[0]);
  return formData;
};

// Reset Field
function restField() {
  txtFullName.value = '';
  txtEmail.value = '';
  txtLocation.value = '';
  txtMobile.value = '';
  txtFile.value = '';
  txtCurrentCompany.value = '';
  txtCurrentTitle.value = '';
  txtCurrentExperience.value = '';
  textProfileURL.value = '';
  txtHearJob.value = '';
}

// Submit
btnSubmit.addEventListener('click', async (e) => {
  e.preventDefault();
  if (submitCount < 1) {
    if (
      validate.name(txtFullName) ||
      validate.location(txtLocation) ||
      validate.number(txtMobile) ||
      validate.email(txtEmail) ||
      validate.fileValidation(txtFile) ||
      validate.minText(txtCurrentCompany) ||
      validate.minText(txtCurrentTitle) ||
      validate.currentExperience(txtCurrentExperience)
    ) {
      e.stopPropagation();
    } else {
      btnSubmit.setAttribute('disabled', true);
      btnSubmit.innerHTML = `
    <div class="spinner-border spinner-border-sm" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
  `;
      submitCount++;

      let form_data = new FormData();
      form_data.append('file', txtFile.files[0]);

      let data = await jsonData();
      let response = await postWith(FILE_UPLOAD_URL, form_data);

      let form_file_res = await postWith(
        API_URL,
        { ...data, resumeUpload: response },
        true
      );

      if (form_file_res == 'Success') {
        lblMsg.classList.add('event-message', 'event-message--success');
        lblMsg.innerHTML = 'Your application has been successfully submitted.';
        restField();
        setInterval(() => {
          lblMsg.innerHTML = '';
          lblMsg.classList.remove('event-message', 'event-message--success');
          btnSubmit.removeAttribute('disabled');
          btnSubmit.innerHTML = SUBMIT;
        }, 5000);
      } else {
        lblMsg.classList.add('event-message', 'event-message--danger');
        lblMsg.innerHTML = 'Something went wrong!';
        restField();
        setInterval(() => {
          lblMsg.innerHTML = '';
          lblMsg.classList.remove('event-message', 'event-message--danger');
          btnSubmit.removeAttribute('disabled');
          btnSubmit.innerHTML = SUBMIT;
        }, 5000);
      }
    }
  }
});
